//@flow
import React from 'react';
import Marker from 'assets/images/marker.png';
import { CallToAction } from 'components/atoms/callToAction';
//eslint-disable next-line
import './styles.scss';

type Props = {
  mode: string,
  onClick: void,
  text: string,
};

export const BookTableButton = (props: Props) => {
  const { mode, onClick, text } = props;

  return (
    <CallToAction
      text={text}
      onClick={onClick}
      className={'book-table'}
      mode={mode}
      icon={Marker}
    />
  );
};
